import React from 'react';
import { connect } from "react-redux";
import { setSelected,setSelectedType } from "../../familyMemberCellularSaleSlice";

const Option=(props)=>{
    return (
        <div className="option" >
        <input
          type="radio"
          id={props.optionKey}
          checked={props.store.selected=== props.optionKey}
          onChange={() => {
            props.setSelected(props.optionKey)
            props.setSelectedType(props.val?.optionType)
          }}
        />
        <label htmlFor={props.optionKey}>
          <div className="radio-icon"></div>
          <div className="details"> {props.val.heading} </div>
        </label>
      </div>
    );
}
const mapStateToProps = (state) => {
  return {
    store: state.familyMemberCellularSale,
  };
};

const mapDispatchToProps = {
  setSelected,
  setSelectedType,
};

export default connect(mapStateToProps, mapDispatchToProps)(Option);
